__turbopack_context__.v({
  "suggestionChip": "qfj13G_suggestionChip",
  "suggestionsList": "qfj13G_suggestionsList",
});
